/**
 * src/actions/mentions-store.js
 * localStorageに対し、「読んでみて！」のリストを格納、取得、クリア
 */

import PermanentStore from './permanent-store'
import difference from 'lodash/difference'
import each from 'lodash/each'

const KEY = "gambaApp.mentions"
const store = PermanentStore(KEY, [])

export default {
  get: store.get,
  clear: store.clear,

  /**
   * 渡された「読んでみて」リストに、Storageから取得したリスト（前回Storageに格納しておいた「読んでみて」リスト）を
   * 追加したものを、Storageに格納する。
   */
  set : (mentions_list)=> {
    store.get((storage_list)=> {
      var storage_ids = difference(storage_list, mentions_list)
      each(storage_ids, (user)=> mentions_list.push(user))
      store.set(mentions_list)
    })
  },
} 


// WEBPACK FOOTER //
// ./src/actions/mentions-store.js